import React from "react";
import { CUISINES } from "../../utils/cuisine";
import { useTranslation } from "react-i18next";

function CuisinePicker({ value, onChange }) {
  const { t } = useTranslation();

  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value || null)}
      className="w-full px-3 py-2.5 bg-th-surface border border-th-border rounded-xl text-base text-th-text focus:outline-none focus:border-th-accent-border focus:ring-1 focus:ring-th-accent-border transition-all appearance-none"
    >
      <option value="">{t("upload.selectCuisine")}</option>
      {CUISINES.map((c) => (
        <option key={c} value={c}>{c}</option>
      ))}
    </select>
  );
}

export default CuisinePicker;
